export var AlertType;
(function (AlertType) {
    AlertType["SuccessRate"] = "SuccessRate";
    AlertType["Duration"] = "Duration";
})(AlertType || (AlertType = {}));
export var AlertStatus;
(function (AlertStatus) {
    AlertStatus["Alerting"] = "alerting";
    AlertStatus["Ok"] = "ok";
})(AlertStatus || (AlertStatus = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel["Info"] = "INFO";
    LogLevel["Warn"] = "WARN";
    LogLevel["Error"] = "ERROR";
    LogLevel["Debug"] = "DEBUG";
})(LogLevel || (LogLevel = {}));
export var TransactionAction;
(function (TransactionAction) {
    TransactionAction["Start"] = "START";
    TransactionAction["Finish"] = "FINISH";
})(TransactionAction || (TransactionAction = {}));
export const InternalTransactions = {
    ComponentLoad: 'PANORAMA_COMPONENT_LOAD',
};
//# sourceMappingURL=enum-types.js.map